var _circle, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5556 14.782H24.3512L26.6189 12.5143L26.7301 11.5511C22.5094 7.82537 16.068 8.22786 12.3422 12.4485C11.307 13.6199 10.5568 15.0153 10.1465 16.5251C10.3986 16.4217 10.679 16.4045 10.9421 16.4781L15.4776 15.7295C15.4776 15.7295 15.7078 15.3474 15.8284 15.3708C17.8455 13.1548 21.2409 12.8964 23.5713 14.782H23.5556Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8499 16.525C29.3283 14.6049 28.2587 12.8791 26.7709 11.5604L23.5885 14.7427C24.9322 15.8406 25.6981 17.4959 25.6652 19.2312V19.7966C27.2297 19.7966 28.4983 21.0651 28.4983 22.6296C28.4983 24.1942 27.2297 25.4627 25.6652 25.4627H19.999L19.4336 26.0359V29.4343L19.999 29.9997H25.6652C29.734 30.031 33.0588 26.7579 33.0902 22.6891C33.109 20.2178 31.8921 17.9063 29.8499 16.525Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3252 29.9632H19.9914V25.4278H14.3252C13.9212 25.4278 13.5234 25.3401 13.1553 25.1725L12.3597 25.42L10.0763 27.6877L9.87744 28.4833C11.157 29.4511 12.72 29.9711 14.3252 29.9632Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3249 15.2519C10.2545 15.2754 6.97663 18.594 7.00013 22.6642C7.01422 24.9367 8.07448 27.076 9.87709 28.4604L13.1628 25.1747C11.7376 24.531 11.1034 22.8522 11.747 21.427C12.3907 20.0019 14.0696 19.3676 15.4948 20.0113C16.1228 20.2947 16.6255 20.799 16.9105 21.427L20.1963 18.1413C18.7993 16.3121 16.6255 15.2425 14.3249 15.2519Z",
    fill: "#FBBC05"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.d4d9f242cbad237ba8bcd7fb3f278d7f.svg";
export { ForwardRef as ReactComponent };